import script from "./SpinnerLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpinnerLoader.vue?vue&type=script&lang=ts&setup=true"

import "./SpinnerLoader.vue?vue&type=style&index=0&id=a2c0b8d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2c0b8d0"]])

export default __exports__